import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';

document.addEventListener('DOMContentLoaded', function () {
    gsap.registerPlugin(ScrollTrigger);

    //Animate all elements from bottom to top with a fade
    let jsRevealbt = Array.prototype.slice.call(document.querySelectorAll('.js-reveal.bottom-top'));

    jsRevealbt.forEach(function (el) {

        gsap.to(el, {
            scrollTrigger: el,
            y: 0,
            opacity: 1
        });
    });

    //Parallax on image in block hero
    let blockHero = Array.prototype.slice.call(document.querySelectorAll('.block_hero'));

    blockHero.forEach(function (el) {
        ScrollTrigger.matchMedia({
            '(min-width: 1024px)': function () {
                let tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: el,
                        start: 'top top+=96',
                        end: 'bottom top+=96',
                        pin: false,
                        scrub: true
                    }
                });

                tl.to(el.querySelector('picture'), {y: 100, duration: 2});
            }
        });
    });

    //Parallax block content image switch
    let imageSwitch = Array.prototype.slice.call(document.querySelectorAll('.block_content_image_switch'));

    imageSwitch.forEach(function (el) {
        ScrollTrigger.matchMedia({
            '(min-width: 768px)': function () {
                let tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: el,
                        start: 'top bottom',
                        end: 'bottom top+=96',
                        pin: false,
                        scrub: true
                    }
                });

                tl.to(el.querySelector('.image'), {y: -50, duration: 2});
            },

            '(max-width: 767px)': function () {
                let tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: el,
                        start: 'top bottom',
                        end: 'top top',
                        pin: false,
                        scrub: true
                    }
                });

                tl.to(el.querySelector('.image'), {y: 0, duration: 2});
            }
        });

        //Parallax block image video
        let imageVideo = Array.prototype.slice.call(document.querySelectorAll('.block_image_video'));

        imageVideo.forEach(function (el) {
            ScrollTrigger.matchMedia({
                '(min-width: 1024px)': function () {
                    let tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: el,
                            start: 'top bottom',
                            end: 'bottom center',
                            pin: false,
                            scrub: true
                        }
                    });

                    tl.to(el.querySelector('.inner .color-line'), {y: 0, duration: 2});
                }
            });
        });
    });
});
